import {DEFAULT_ZONE_POINT} from '@yandex-taxi/react-integration-api'
import {MapQueryParams} from '@yandex-taxi/react-ymaps/build/main/utils/loadYMaps'

export const MAX_POINTS_AMOUNT = 7
export const DEFAULT_ZOOM = 12
export const MAX_ZOOM = 21
export const PLACEMARK_ZOOM = 16

export enum Tariff {
  COURIER = 'courier',
  EXPRESS = 'express',
  CARGO = 'cargo',
}

export const MAP_OPTIONS: Partial<ymaps.IMapConstructorOptions> = {
  suppressMapOpenBlock: true,
  yandexMapDisablePoiInteractivity: true,
  copyrightUaVisible: false,
  copyrightProvidersVisible: false,
  copyrightLogoVisible: false,
  autoFitToViewport: 'always',
}

export const MAP_STATE: Partial<ymaps.IMapConstructorState> = {
  center: DEFAULT_ZONE_POINT,
  zoom: DEFAULT_ZOOM,
  controls: [],
  margin: [40, 10, 40, 10],
  behaviors: ['drag', 'dblClickZoom', 'scrollZoom', 'multiTouch'],
}

export const MAP_QUERY: MapQueryParams = {
  coordorder: 'longlat',
  load: 'Map,Placemark,GeoObjectCollection,templateLayoutFactory,util.bounds,util.math.areEqual',
}

export const WITHOUT_ANIMATION: Partial<ymaps.IMapSetBoundsOptions> = {
  useMapMargin: true,
}

export const BOUNDS_ANIMATION: Partial<ymaps.IMapSetBoundsOptions> = {
  ...WITHOUT_ANIMATION,
  checkZoomRange: true,
  timingFunction: 'ease-in-out',
  duration: 600,
}
